module.exports = __webpack_public_path__ + "static/media/icon_occlusal_surface_2.767ef672.svg";